import { useEffect, useState } from 'react';
import useStateWithCallback from 'use-state-with-callback';
import Selection from '@simonwep/selection-js';

const useSelection = (selectables, boundaries, onChange, dataField = 'id', custom = { class: 'selection' }, onSelecting = null) => {
  // const [selecting, setSelecting] = useState(false);

  const [selecting, setSelecting] = useStateWithCallback(false, i => {
    if(onSelecting) onSelecting(i);
  });

  useEffect(() => {
    const selection = Selection.create({
      selectables,
      boundaries,
      ...custom
    });

    const onStart = ({inst, selected, oe}) => {
			setSelecting(true);
			if (!oe.ctrlKey && !oe.metaKey) {
				for (const el of selected) {
					inst.removeFromSelection(el);
				}
				inst.clearSelection();
			}
    }

    const onMove = ({ selected }) => {
      onChange(
        selected.map(el => parseInt(el.dataset[dataField]))
      )
    }

    const onStop = ({ inst }) => {
      inst.keepSelection()
      setTimeout(() => {
        setSelecting(false)
      }, 0)
    }

    selection.on('start', onStart);
    selection.on('move', onMove);
    selection.on('stop', onStop);

    return () => {
      selection.off('start', onStart);
      selection.off('move', onMove);
      selection.off('stop', onStop);
    }
  }, [])

  return selecting;
}

export default useSelection;
